// src/hooks/useVersionCheck.ts
import { useEffect } from "react";

// Mendefinisikan struktur data dari version.json
interface VersionData {
  version: string;
}

export const useVersionCheck = (): void => {
  useEffect(() => {
    const checkVersion = async (): Promise<void> => {
      try {
        const response = await fetch("/version.json?t=" + Date.now());

        // Memastikan tipe data yang diterima sesuai dengan interface
        const data: VersionData = await response.json();

        const currentVersion = localStorage.getItem("app-version");

        if (currentVersion && currentVersion !== data.version) {
          // Versi berbeda, berarti ada update!
          localStorage.setItem("app-version", data.version);

          // Memuat ulang halaman
          window.location.reload();
        } else {
          localStorage.setItem("app-version", data.version);
        }
      } catch (error) {
        console.error("Gagal cek versi:", error);
      }
    };

    // Panggil segera saat komponen ter-mount
    checkVersion();

    // Opsional: Cek setiap 1 jam (3600000 ms)
    const interval = setInterval(checkVersion, 3600000);
    // const interval = setInterval(checkVersion, 10000);

    return () => clearInterval(interval);
  }, []);
};
